// tracking: video_page.learning_plan_modal_close, video_page.learning_plan_modal_close_escape
//
// Every Unpoly overlay reports how it was closed. An overlay that wants an element.id marks the element
// carrying its `up-id` (and its `data-tracking-context`) with `data-modal-tracking`; the layer element
// itself is the <up-modal> wrapper, which the markup does not control. Overlays without the marker keep
// the element-less push they have always sent.
import { trackEvent, trackElementInteraction } from 'frontend/shared/javascripts/util/analytics'

export const MODAL_TRACKING_ATTRIBUTE = 'data-modal-tracking'

up.on('up:layer:dismiss', (event) => {
  // A click outside stays untracked on purpose (tracking concept, open point 13).
  if (event.value === ':outside') return

  const eventName = event.value === ':key' ? 'modal.escapeKey.press' : 'modal.closeButton.click'
  const marked = event.layer?.element?.querySelector<HTMLElement>(`[${MODAL_TRACKING_ATTRIBUTE}]`)

  if (marked) {
    // An overlay's own text is its whole content, so it never travels.
    trackElementInteraction(marked, eventName, { text: '' })
  } else {
    trackEvent(eventName)
  }
})
